import { Component, ViewChild } from '@angular/core';
import { RegistrationFormComponent } from '../../components/registration-form/registration-form.component';
import { SubscriptionTracker } from 'src/app/shared/utilities/subscription-tracker';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { SubHeaderComponent } from '../../../shared/components/sub-header/sub-header.component';


@Component({
    selector: 'app-registration-page',
    templateUrl: './user-registration-page.component.html',
    styleUrls: ['./user-registration-page.component.scss'],
    imports: [FooterComponent, SubHeaderComponent, RegistrationFormComponent]
})
export class UserRegistrationPageComponent extends SubscriptionTracker {
    @ViewChild(RegistrationFormComponent) registrationFormComponent: RegistrationFormComponent;
    constructor() {
        super();
    }
}
